import { setUpModals } from '~/components/shared/controllers/modalController';
import './cardsSectionController';
import './relatedArticlesController';
import './moreProvidersLinkController';
import './nativeAppLinks';
import './growBrandClickAnywhereController';

setUpModals();
